import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import SplitPDFImgeListScreen from "./SplitPDFImgeListScreen";
import LoadingBar from "react-top-loading-bar";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import { BASE_URL } from "../Config";
import MiscFAQ from "../misc_components/MiscFAQ";
import MiscRecommendedPages from "../misc_components/MiscRecommendedPages";

function SplitPDFMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "Split PDF file" };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/split_pdf", title: "PDF Splitter" },
    data2: { link: "/split_pdf", title: "Extract PDF pages" },
    data3: { link: "/split_pdf", title: "PDF Seperator" },
  };

  //reference loading bar
  const loadingBarRef = useRef(null);

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Split PDF files online easily. Separate pages, extract ranges, or divide PDFs quickly with our fast, secure, and simple PDF splitter tool."
      ></meta>
      <meta
        name="keywords"
        content="split pdf, split pdf online, pdf splitter, separate pdf pages, extract pdf pages, divide pdf files, pdf page splitter, split pdf tool, online pdf splitter, split pdf by pages, split pdf by range, pdf editor online, pdf management tool, split pdf free, pdf document splitter, split pdf into two pdfs,"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <SplitPDFImgeListScreen title={title} />
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={false}
            filetype={{ "application/pdf": [".pdf"] }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our Split PDF tool is a fast, secure, and easy-to-use online PDF splitter designed to help users efficiently split PDF files online without compromising quality or privacy, making it the perfect solution for students, professionals, and businesses who need to split large PDF documents, extract specific pages, or divide files into smaller, more manageable parts. With this powerful PDF split tool, you can quickly split PDF by page range, separate PDF pages, or extract pages from PDF files in just a few clicks, all directly from your browser with no software installation required. This free PDF splitter online works seamlessly across all devices and operating systems, including Windows, macOS, Android, and iOS, ensuring maximum compatibility and convenience. The tool preserves original formatting, layout, and quality while delivering high-speed processing, making it ideal for handling contracts, reports, invoices, eBooks, and scanned documents. Built with advanced security standards, our secure PDF splitting tool encrypts file transfers and automatically deletes uploaded documents after processing, ensuring complete data protection. Whether you need to split PDF into individual pages, create multiple PDFs from one file, or simply organize your documents more effectively, this best PDF splitter online offers a reliable, user-friendly, and professional solution to manage PDFs efficiently and save valuable time." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Convert",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Split PDF"
            why_use={[
              {
                title: "Easily Manage Large PDF Files",
                description:
                  "Split PDF tool helps users split large PDF files into smaller, more manageable documents, making storage, sharing, and organization much easier for both personal and professional use.",
              },
              {
                title: "Extract Specific Pages Quickly",
                description:
                  "With an advanced PDF splitter, you can extract pages from PDF files without editing the entire document, saving time when only certain pages are needed.",
              },
              {
                title: "Improve Document Sharing",
                description:
                  "By using an online PDF split tool, users can split PDF documents to share only relevant pages, reducing file size and improving email and upload efficiency.",
              },

              {
                title: "Enhance Workflow Efficiency",
                description:
                  "A reliable PDF split tool streamlines document workflows by allowing users to split PDF by page range or separate pages instantly, which is especially useful in offices and businesses.",
              },
              {
                title: "Maintain Original Quality and Format",
                description:
                  "The best PDF splitter ensures that text, images, and formatting remain intact when you split PDF files, delivering professional-quality results every time.",
              },
              {
                title: "Increase Data Security",
                description:
                  "Instead of sharing full documents, a secure PDF splitting tool lets users share only required pages, helping protect sensitive and confidential information.",
              },
              {
                title: "Free to Use",
                description:
                  "You don't need any account or sign up to start using our service. Very little time required to get your jobs done and the great part is it is free to use. And our app works completely offline.",
              },
              {
                title: "Save Time and Resources",
                description:
                  "Using a free PDF splitter online or offline solution eliminates the need for re-creating documents, making PDF splitting a fast and cost-effective process.",
              },
              {
                title: "Work Across Devices and Platforms",
                description:
                  "Modern PDF split tools work on multiple devices and operating systems, allowing users to split PDF files online or offline anytime, anywhere.",
              },
            ]}
          />
          {/* FAQ */}
          <MiscFAQ
            faq_list={[
              {
                title: "What is a PDF splitter?",
                description:
                  "A PDF splitter is a tool that divides a PDF document into smaller files or separates selected pages from the original document. It is useful for organizing reports, extracting chapters, and sharing specific pages.",
              },
              {
                title: "How can I split a PDF for free?",
                description:
                  "Open the PDF splitter on ShivaPDF.com, select your PDF file, choose the pages or splitting method, and process the document. Download the resulting PDF files when the operation is complete.",
              },
              {
                title: "Can I split a PDF offline?",
                description:
                  "Yes, if the PDF splitter supports local processing, you can split PDF files without an internet connection after the tool and its required resources have loaded. Offline availability depends on the implementation.",
              },
              {
                title: "Does ShivaPDF upload my PDF when splitting it?",
                description:
                  "A locally processed PDF splitter can separate pages directly in your browser without sending the document to a server. Check the tool's implementation and privacy policy to confirm how your files are handled.",
              },
              {
                title: "How do I split a PDF into multiple files?",
                description:
                  "Select your PDF in the splitting tool and choose how you want to divide it, such as by page ranges or individual pages, if supported. Process the document and save the resulting PDF files.",
              },
              {
                title: "Can I split a PDF into individual pages?",
                description:
                  "Yes, if the tool supports splitting every page separately, you can turn a multi-page PDF into individual single-page PDF files. This is useful when you need to share or manage each page independently.",
              },
              {
                title: "Can I extract specific pages from a PDF?",
                description:
                  "A PDF splitter can extract selected pages when page selection is supported. Choose the pages you need and create a separate PDF containing only those pages.",
              },
              {
                title: "Can I split a PDF by page range?",
                description:
                  "Yes, if page-range splitting is available, you can divide a PDF using ranges such as pages 1–5 and 6–10. This is helpful for separating chapters, sections, or groups of pages.",
              },
              {
                title: "Can I split a PDF into equal parts?",
                description:
                  "If the tool supports splitting by page count, you can divide a PDF into groups containing a chosen number of pages. The final group may contain fewer pages if the total cannot be divided evenly.",
              },
              {
                title: "Can I split a PDF into two separate files?",
                description:
                  "Yes, you can create two separate PDF files if the tool supports page-range splitting. Choose where to divide the original document and save each section as a separate file.",
              },
              {
                title: "Can I split a large PDF file?",
                description:
                  "Large PDFs can often be split, but processing depends on the tool's file-size limits, available device memory, and document complexity. If processing fails, try a smaller file or use a device with more available memory.",
              },
              {
                title: "Can I split a scanned PDF?",
                description:
                  "Yes, scanned PDFs can generally be split because their pages can be separated without recognizing the text. The resulting files retain the scanned page content, subject to the tool's processing capabilities.",
              },
              {
                title: "Can I split a password-protected PDF?",
                description:
                  "A password-protected PDF may need to be unlocked before it can be split. You must have the appropriate password and permission to modify or extract content from the document.",
              },
              {
                title: "Will splitting a PDF reduce its file size?",
                description:
                  "Splitting a PDF creates smaller documents, but it does not necessarily reduce the combined size of all the resulting files. To reduce storage size, use a PDF compression tool.",
              },
              {
                title: "Will splitting a PDF affect its quality?",
                description:
                  "Splitting a PDF normally separates existing pages without intentionally reducing their quality. However, you should open the resulting files to verify that text, images, formatting, and page order remain correct.",
              },
              {
                title: "Can I split a PDF without changing the original file?",
                description:
                  "Yes, a PDF splitter can create separate output files while leaving the original document unchanged. Keep a backup of the original PDF if you need to preserve the complete document.",
              },
              {
                title: "Can I split a PDF on my phone?",
                description:
                  "You can split PDFs on a compatible iPhone or Android device using a mobile-friendly browser-based tool. Open ShivaPDF.com, select your document, and use the available splitting options.",
              },
              {
                title: "Can I split a PDF on Windows or Mac?",
                description:
                  "A browser-based PDF splitter can work on compatible Windows and Mac computers. Open ShivaPDF.com in a supported browser, select the PDF, and split it using the available controls.",
              },
              {
                title: "Can I split a PDF without installing software?",
                description:
                  "A browser-based PDF splitter lets you separate PDF pages without installing a dedicated desktop application. The available splitting options depend on the tool's supported features.",
              },
              {
                title: "Is ShivaPDF's PDF splitter free?",
                description:
                  "ShivaPDF provides browser-based PDF tools for common document tasks. Check the PDF splitter page for current availability, file-size limits, and any usage restrictions.",
              },
              {
                title: "Can I split a PDF without creating an account?",
                description:
                  "You may be able to split PDF files without registering if the tool does not require an account. Check the current ShivaPDF page for access requirements and any applicable limits.",
              },
              {
                title: "Why can't I split my PDF file?",
                description:
                  "The PDF may be corrupted, password-protected, too large, or incompatible with the tool. Try opening the file in a PDF viewer, checking its permissions, or using a valid copy of the document.",
              },
              {
                title: "How do I download split PDF files?",
                description:
                  "After the splitting process finishes, use the available download controls to save the resulting PDF files. Depending on the tool, you may be able to download each file separately or download multiple files in a bundle.",
              },
              {
                title: "Is it safe to split confidential PDF documents online?",
                description:
                  "For confidential documents, choose a tool with a clear privacy policy and verified local processing if you want files to remain on your device. Avoid uploading sensitive documents unless you understand how the service handles them.",
              },
            ]} />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${6504000491}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Recommended Tools */}
          <MiscRecommendedPages />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default SplitPDFMain;
